import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const HELP_CENTER = `/help-center-faq-list`;


export const getHelpCenterData = createAsyncThunk(
  "getHelpCenterData",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${HELP_CENTER}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

